// <s-read-more> — clamps [data-read-more-body] (CSS line-clamp via data-expanded) and reveals the
// [data-read-more-toggle] button only when the text actually overflows. The button targets this
// element with command="--toggle"; its label swaps between data-label-more / data-label-less.
class SReadMore extends HTMLElement {
  #ac;
  #ro;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    this.addEventListener('command', (e) => {
      if (e.command === '--toggle') this.#toggle();
    }, opts);
    this.#ro = new ResizeObserver(() => this.#measure());
    const body = this.querySelector('[data-read-more-body]');
    if (body) this.#ro.observe(body);
    this.#measure();
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#ro?.disconnect();
  }

  #measure() {
    const body = this.querySelector('[data-read-more-body]');
    const button = this.querySelector('[data-read-more-toggle]');
    if (!body || !button) return;
    if (this.hasAttribute('data-expanded')) return;
    button.hidden = body.scrollHeight <= body.clientHeight + 1;
  }

  #toggle() {
    const button = this.querySelector('[data-read-more-toggle]');
    const expanded = !this.hasAttribute('data-expanded');
    this.toggleAttribute('data-expanded', expanded);
    if (!button) return;
    button.setAttribute('aria-expanded', String(expanded));
    const label = button.querySelector('[data-label]') || button;
    label.textContent = expanded ? button.dataset.labelLess : button.dataset.labelMore;
  }
}

customElements.define('s-read-more', SReadMore);
